/* Social video grid — lightbox player for the POV band's video cards.
 *
 * Tiles are server-rendered by snippets/cv-social-grid.liquid as
 * <button data-ddc-video data-platform data-id ...>. Nothing from YouTube or
 * Instagram (iframe or script) is requested until a shopper presses one.
 *
 * Everything is delegated from `document`, so tiles re-rendered by the theme
 * editor (shopify:section:load) keep working without re-binding.
 */
(function () {
  if (window.__ddcSocial) return;
  window.__ddcSocial = true;

  var doc = document;
  var dialog, panel, frame, shop, closeBtn, opener = null, lockedY = 0, bodyStyle = '';

  /* ---- thumbnails: oar2.jpg (9:16 still) -> hqdefault.jpg ---------------
     A missing i.ytimg.com still answers 404 with a 120x90 grey image, which
     some browsers report as a successful load, so check the size as well. */
  function fallback(img) {
    var fb = img.getAttribute('data-fallback');
    if (!fb || img.getAttribute('data-fell-back')) return;
    img.setAttribute('data-fell-back', '1');
    img.classList.add('is-fallback');
    img.src = fb;
  }
  function checkThumb(img) {
    if (!img.complete || img.getAttribute('data-fell-back')) return;
    if (img.naturalWidth === 0 || img.naturalWidth <= 120) fallback(img);
  }
  doc.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.hasAttribute('data-fallback')) fallback(t);
  }, true);
  doc.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.hasAttribute('data-fallback')) checkThumb(t);
  }, true);
  function scanThumbs() {
    var list = doc.querySelectorAll('img[data-fallback]');
    for (var i = 0; i < list.length; i++) checkThumb(list[i]);
  }

  /* ---- player ----------------------------------------------------------- */
  function el(tag, cls, attrs) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    return n;
  }

  function build() {
    if (dialog) return;
    /* Appended to <body>: a fixed element inside a canvas stage would be
       positioned (and scaled) relative to the transformed stage instead. */
    dialog = el('dialog', 'ddc-svm', { 'aria-modal': 'true', 'aria-label': 'Video player' });
    var wrap = el('div', 'ddc-svm__wrap');
    var startTrap = el('span', 'ddc-svm__sentinel', { tabindex: '0' });
    var endTrap = el('span', 'ddc-svm__sentinel', { tabindex: '0' });
    panel = el('div', 'ddc-svm__panel');
    closeBtn = el('button', 'ddc-svm__close', { type: 'button', 'aria-label': 'Close video' });
    frame = el('div', 'ddc-svm__frame');
    shop = el('a', 'ddc-svm__shop');
    shop.hidden = true;

    panel.appendChild(frame);
    panel.appendChild(shop);
    wrap.appendChild(panel);
    dialog.appendChild(startTrap);
    dialog.appendChild(closeBtn);
    dialog.appendChild(wrap);
    dialog.appendChild(endTrap);
    doc.body.appendChild(dialog);

    closeBtn.addEventListener('click', close);
    /* Backdrop: anything outside the player panel (clicks inside the iframe
       never reach this document). */
    dialog.addEventListener('click', function (e) {
      if (e.target !== closeBtn && !panel.contains(e.target)) close();
    });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

    /* Focus trap: tabbing off either end wraps to the other. */
    startTrap.addEventListener('focus', function () {
      (shop.hidden ? (frame.querySelector('iframe') || closeBtn) : shop).focus();
    });
    endTrap.addEventListener('focus', function () { closeBtn.focus(); });
  }

  function isOpen() { return !!(dialog && (dialog.open || dialog.hasAttribute('open'))); }

  function lockScroll() {
    var html = doc.documentElement, body = doc.body;
    lockedY = window.pageYOffset || html.scrollTop || 0;
    var sbw = window.innerWidth - html.clientWidth;
    bodyStyle = body.getAttribute('style') || '';
    /* position:fixed is what actually stops iOS Safari scrolling underneath;
       the scrollbar's width is kept as padding so the canvas does not rescale. */
    body.style.position = 'fixed';
    body.style.top = -lockedY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    if (sbw > 0) body.style.paddingRight = sbw + 'px';
    html.classList.add('ddc-svm-lock');
  }
  function unlockScroll() {
    var html = doc.documentElement;
    if (bodyStyle) doc.body.setAttribute('style', bodyStyle);
    else doc.body.removeAttribute('style');
    html.classList.remove('ddc-svm-lock');
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedY);
    html.style.scrollBehavior = prev;
  }

  function embedFor(platform, id, kind) {
    var safe = encodeURIComponent(id);
    if (platform === 'youtube') {
      return 'https://www.youtube-nocookie.com/embed/' + safe +
        '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
    }
    return 'https://www.instagram.com/' + (kind === 'reel' ? 'reel' : 'p') + '/' + safe + '/embed/';
  }

  function open(tile) {
    var platform = tile.getAttribute('data-platform');
    var id = tile.getAttribute('data-id');
    if (!id || (platform !== 'youtube' && platform !== 'instagram')) return;
    build();

    var caption = tile.getAttribute('data-caption') || 'Video';
    var iframe = el('iframe', '', {
      src: embedFor(platform, id, tile.getAttribute('data-kind')),
      title: (platform === 'youtube' ? 'YouTube video: ' : 'Instagram reel: ') + caption,
      allow: 'autoplay; encrypted-media; picture-in-picture; fullscreen; clipboard-write',
      allowfullscreen: '',
      referrerpolicy: 'strict-origin-when-cross-origin'
    });
    frame.className = 'ddc-svm__frame ddc-svm__frame--' + platform;
    frame.style.height = '';
    frame.innerHTML = '';
    frame.appendChild(iframe);
    dialog.setAttribute('aria-label', 'Video player: ' + caption);

    var pUrl = tile.getAttribute('data-product-url');
    if (pUrl) {
      shop.href = pUrl;
      shop.textContent = 'Shop ' + (tile.getAttribute('data-product-title') || 'this product');
      shop.hidden = false;
    } else {
      shop.hidden = true;
      shop.removeAttribute('href');
    }

    opener = tile;
    lockScroll();
    if (typeof dialog.showModal === 'function') {
      try { dialog.showModal(); } catch (err) { dialog.setAttribute('open', ''); }
    } else {
      dialog.setAttribute('open', '');
    }
    closeBtn.focus();
  }

  function close() {
    if (!isOpen()) return;
    frame.innerHTML = ''; /* removing the iframe stops playback */
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    dialog.removeAttribute('open');
    unlockScroll();
    if (opener && doc.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (err) { opener.focus(); }
    }
    opener = null;
  }

  /* Instagram's embed reports its content height (the same message its
     embed.js listens for); size the white card to it, within the viewport. */
  window.addEventListener('message', function (e) {
    if (!isOpen() || !/^https:\/\/www\.instagram\.com$/.test(e.origin)) return;
    var data = e.data;
    try { if (typeof data === 'string') data = JSON.parse(data); } catch (err) { return; }
    if (!data || data.type !== 'MEASURE' || !data.details) return;
    var h = parseInt(data.details.height, 10);
    if (h > 0 && frame.classList.contains('ddc-svm__frame--instagram')) {
      frame.style.height = 'min(' + h + 'px, calc(100vh - 128px))';
    }
  });

  doc.addEventListener('click', function (e) {
    var tile = e.target.closest && e.target.closest('[data-ddc-video]');
    if (!tile) return;
    e.preventDefault();
    open(tile);
  });

  doc.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) { e.preventDefault(); close(); }
  });

  doc.addEventListener('shopify:section:load', scanThumbs);
  doc.addEventListener('shopify:section:unload', close);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scanThumbs);
  else scanThumbs();
  window.addEventListener('load', scanThumbs);
})();
